var React = require('react');

function StreamlineLine27AddCircle1 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","key":0},[React.createElement("circle",{"cx":"11.5","cy":"11.5","r":"11","key":0}),React.createElement("path",{"d":"M11.5 5.5v12M17.5 11.5h-12","key":1})]),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineLine27AddCircle1.displayName = "StreamlineLine27AddCircle1";

StreamlineLine27AddCircle1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine27AddCircle1;

StreamlineLine27AddCircle1.default = StreamlineLine27AddCircle1;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-27-add-circle-1.svg
// module id = 772
// module chunks = 0